import i18n from '@/lang/i18n'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.externalCode'),
            colId: 'code',
            field: 'code',
            width: 150,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.department', 1),
            colId: 'name',
            field: 'name',
            minWidth: 180,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.center', 1),
            colId: 'center.name',
            field: 'center.name',
            minWidth: 180,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.departmentType', 1),
            colId: 'departmentType.name',
            field: 'departmentType.name',
            minWidth: 180,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.email'),
            colId: 'contactInformation.email',
            field: 'contactInformation.email',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.phone'),
            colId: 'contactInformation.mainPhone',
            field: 'contactInformation.mainPhone',
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            colId: 'active',
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]
}
